/**
 * @generated SignedSource<<32e1d8c4197e8799532f06500e31aba9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceTodoEditSetBodyMutation$variables = {
  body: string;
  formattedBody?: string | null;
  id: string;
};
export type useWorkspaceTodoEditSetBodyMutation$data = {
  readonly todoWorkspace: {
    readonly updateBody: {
      readonly body: string | null;
      readonly formattedBody: string | null;
      readonly id: string;
      readonly updatedBySessionId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo" | "WorkspaceTodoEditMainProducts_TodoWorkspace">;
    };
  };
};
export type useWorkspaceTodoEditSetBodyMutation = {
  response: useWorkspaceTodoEditSetBodyMutation$data;
  variables: useWorkspaceTodoEditSetBodyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "body"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formattedBody"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "newBody",
    "variableName": "body"
  },
  {
    "kind": "Variable",
    "name": "newFormattedBody",
    "variableName": "formattedBody"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBySessionId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedBody",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceTodoEditSetBodyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateBody",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainProducts_TodoWorkspace"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceTodoEditSetBodyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateBody",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceProduct",
                "kind": "LinkedField",
                "name": "linkedProducts",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partNumber",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "450ea67149f2a5768930b26c4ac849b3",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceTodoEditSetBodyMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceTodoEditSetBodyMutation(\n  $id: ID!\n  $body: String!\n  $formattedBody: String\n) {\n  todoWorkspace(id: $id) {\n    updateBody(newBody: $body, newFormattedBody: $formattedBody) {\n      id\n      updatedBySessionId\n      body\n      formattedBody\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n      ...WorkspaceTodoEditMainProducts_TodoWorkspace\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment LinkedWorkspaceProductItem_WorkspaceProduct on WorkspaceProduct {\n  id\n  imageUrl\n  partNumber\n  name\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment WorkspaceTodoEditMainProducts_TodoWorkspace on TodoWorkspace {\n  id\n  linkedProducts {\n    id\n    ...LinkedWorkspaceProductItem_WorkspaceProduct\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "ea7bb75000a2df796374e3b8af901fb1";

export default node;
